// video.js

import 'featherlight';
import { Cookie } from './cookie.js';
import { cookiebar } from './cookie.js';

export const video = {
    /**
     * Initialiseert de video-functionaliteit en koppelt de klik-events.
     * @param {object} $ - De jQuery-instantie.
     */
    init($) {
        $('.cb-video__button').on('click', (e) => {
            e.preventDefault();

            const $target = $(e.currentTarget);
            const videoId = $target.data('videoid');
            const videoProvider = $target.data('videoprovider');
            const videoFallback = $target.data('videosrc');

            // 🔑 CRUCIALE AANPASSING: Haal de naam op, gebruik de ID als fallback (A11y Safety Net)
            const videoName = $target.data('videoname') || `Video ID: ${videoId}`;

            this.createVideoPlayer($, videoId, videoProvider, videoFallback, videoName);
        });
    },

    /**
     * Creëert en opent de video-speler in een Featherlight modal.
     * @param {object} $ - De jQuery-instantie.
     * @param {string} videoId - De ID van de video.
     * @param {string} videoProvider - De provider (youtube/vimeo).
     * @param {string} videoFallback - De fallback URL.
     * @param {string} videoName - De naam van de video voor het title-attribuut (of fallback ID).
     */
    createVideoPlayer($, videoId, videoProvider, videoFallback, videoName) {
        // Zorg ervoor dat de opslagcontainer wordt verwijderd voor de volgende open actie
        $('.video-storage').remove();

        if (Cookie.getCookie(cookiebar.cookieBarCookieName) === "true") {
            let videoEmbed = null;

            if (videoProvider === 'youtube') {
                videoEmbed = this.createYoutubeEmbed(videoId, videoName);
            } else if (videoProvider === 'vimeo') {
                videoEmbed = this.createVimeoEmbed(videoId, videoName);
            }

            if (videoEmbed) {
                const $videoStorage = $('<div class="lightbox-storage video-storage video-storage--'+videoProvider+'"></div>');
                $('body').append($videoStorage);

                $videoStorage.html('<div class="video-container">'+videoEmbed+'</div>');

                $.featherlight($videoStorage, {
                    // A11y Fix: Stopt de video en lost de keyboard trap op bij het sluiten
                    afterClose: function() {
                        const $iframe = $videoStorage.find('iframe');

                        if ($iframe.length) {
                            $iframe.attr('src', '');
                            $iframe.remove();
                        }

                        $videoStorage.remove();
                    }
                });
            }

        } else {
            // Logica voor als cookies NIET zijn geaccepteerd (Fallback)
            const $videoStorage = $('<div class="lightbox-storage video-storage video-storage--'+videoProvider+'"></div>');
            $('body').append($videoStorage);

            $videoStorage.html(`
                <div style="min-height:100px; max-width: 750px; padding: 40px;" class="message-container message-container-no-cookies">
                    Bij het bekijken van de video worden cookies geplaatst. <br>
                    Accepteer het plaatsen van cookies om deze video te kunnen bekijken of ga naar de video op
                    <a href="${videoFallback}" target="_blank">${videoFallback}</a>.
                </div>
            `);

            $.featherlight($videoStorage, {
                afterClose: function() {
                    $videoStorage.remove();
                }
            });
        }
    },

    /**
     * Genereert de YouTube iframe embed code.
     */
    createYoutubeEmbed(videoId, videoName) {
        // Gebruik de videonaam (met mogelijke ID-fallback) in de title
        const title = `YouTube video speler: ${videoName}`;

        return `<iframe
            id="youtube-player-embed"
            title="${title}"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/${videoId}?rel=0&autoplay=1&autohide=1"
            frameborder="0"
            allow="autoplay; encrypted-media; picture-in-picture"
            allowfullscreen
        ></iframe>`;
    },

    /**
     * Genereert de Vimeo iframe embed code.
     */
    createVimeoEmbed(videoId, videoName) {
        // Gebruik de videonaam (met mogelijke ID-fallback) in de title
        const title = `Vimeo video speler: ${videoName}`;

        return `<iframe
            title="${title}"
            src="https://player.vimeo.com/video/${videoId}?byline=0&portrait=0"
            width="640"
            height="360"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
        ></iframe>`;
    }
};
